<template>
	<div class="counterArea" :class="{small : type == 'SMALL'}">
		<div class="countLeft" @click="preClick()">-</div>
		<input type="text" class="inputText" v-model="number" @blur="inputClick" />
		<div class="countRight" @click="nextClick()">+</div>
	</div>
</template>

<script>
	export default {
		props: ['type','val','id'],
		data() {
			return {
				number: this.val
			}
		},
		methods: {
			preClick() {
				if (this.number <= 0){ 
					
					this.number=0;
					this.$emit('messageSent', {number:this.number,id:this.id});
					return;
				}
				this.number--
				this.$emit('messageSent', {number:this.number,id:this.id});
			},
			nextClick() {
				this.number++
				this.$emit('messageSent', {number:this.number,id:this.id});
			},
			inputClick(event) {
				console.log(event.target.value)
				if (event.target.value < 0) 
				{
					this.number=0;
					this.$emit('messageSent',{number:this.number,id:this.id});
					return ;
				}
				this.number = event.target.value;
				this.$emit('messageSent', {number:this.number,id:this.id});
			}
		}
	}
</script>

<style scoped>
	.counterArea {
		display: flex;
		align-items: center;
	}

	.countLeft,
	.countRight {
		width: 42px;
		height: 42px;
		border: 1px solid #cccccc;
		background-color: #f9f9f9;
		font-size: 15px;
		text-align: center;
		line-height: 42px;
		cursor: pointer;
	}

	.small .countLeft,
	.small .countRight {
		width: 27px;
		height: 28px;
		line-height: 28px;
	}

	.inputText {
		width: 68px;
		height: 42px;
		border: 1px solid #cccccc;
		border-left: 0px;
		border-right: 0px;
		background-color: #fff;
		text-align: center;
		font-synthesis-small-caps: 16px;
		color: #000;
	}

	.small .inputText {
		width: 50px;
		height: 28px;
		line-height: 28px;
	}

	.inputText:focus {
		outline: none;
	}
</style>